<template>
	<div class="submission">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<p class="msg">投递初稿前，请仔细核对个人资料，确保所有必填信息准确无误。点击下方按钮可跳转至对应页面进行提交。</p>
		 <el-button type="primary" round  class="commitFirst" @click="poster">投递初稿</el-button>
		 <p class="msg">通过初审的投稿需及时提交复审材料，点击下方按钮可跳转至对应页面进行相关操作。</p>
		 <el-button type="primary" round class="commitFirst" @click="poster2">提交复审材料</el-button>
		 <div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		methods:{
			poster(){
				this.$router.push({path:'/commit'})
				this.$store.commit('SET_ISPERSON', true)
				this.$store.commit('SET_ISLOGIN', false)
				this.$store.commit('SET_ISCENTER', true)
				this.$store.commit('SET_ISFIRST', false)
			},
			poster2(){
				this.$router.push({path:'/review'})
				this.$store.commit('SET_ISPERSON', true)
				this.$store.commit('SET_ISLOGIN', false)
				this.$store.commit('SET_ISCENTER', true)
				this.$store.commit('SET_ISFIRST', false)
			}
		},
		created(){
			this.$store.commit('SET_ISBLUECOLOR', false)
		}
	}
</script>

<style scoped>
	.submission{
		padding-bottom: 40px; padding-left: 20px;
	}
	.commitFirst{
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 90px auto;
		/*padding: 40px;*/
	}
	.msg{
		padding: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/submission.vue